import React, { useEffect, useState } from "react";
import { CssBaseline } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import GlobalStyle from "../components/GlobalStyle";
import useAuthRedirect from "../hooks/useAuthRedirect";
import { signInMember } from "../redux/slices/memberSlice";

import Footer from "./application layout components/Footer";
import Navbar from "./application layout components/Navbar";
import MenuNavbar from "./application layout components/navbar components/Navbar";
import PoweredBy from "./application layout components/PoweredBy";
import MainContent from "./application layout components/MainContent";
import WebsiteLoader from "./application layout components/WebsiteLoader";
import AgentNavbar from "./application layout components/navbar components/AgentNavbar";

const ContentWrapper = styled("div")({
  display: "flex",
  height: "100%",
  background: "transparent",
});

const MainContentWrapper = styled("div")({
  flex: 1,
  overflow: "auto",
  display: "flex",
  flexDirection: "column",
});

export default function ApplicationLayout() {
  const location = useLocation();
  const dispatch = useDispatch();
  const { authToken } = useSelector((state) => state.memberDetails);

  const [mainContentLoaded, setMainContentLoaded] = useState(false);
  const authStatus = useAuthRedirect();

  const sessionStorageToken = sessionStorage.getItem("authToken");

  // Restore auth token from sessionStorage
  useEffect(() => {
    // if (!authToken && sessionStorageToken) {
    // dispatch(signInMember({ authToken: sessionStorageToken }));
    // }
  }, [authToken, sessionStorageToken, dispatch]);

  // Simulate main content loading delay
  useEffect(() => {
    const timer = setTimeout(() => setMainContentLoaded(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  const path = location.pathname;

  const showNavbar = ["/event-booking/", "/"].some((route) =>
    path.includes(route)
  );

  const showFooter = [
    "/sign-up",
    "/sign-in",
    "/manual-entry",
    "/manual-verification",
    "/resend-notification",
    "/main-gate-entry-back",
    "/add-booking",
    "/booking-stats",
    "/checkIn-logs",
    "/settings",
    "/dependents",
  ].some((route) => path.includes(route));

  const showMenuNavbar = [
    "/sign-up",
    "/sign-in",
    "/main-gate-entry-back",
    "/profile",
    "/manual-entry",
    "/manual-verification",
    "/add-booking",
    // "/login",
    "/resend-notification",
    "/booking-stats",
    "/checkIn-logs",
    "/settings",
    // "/dependents",
  ].some((route) => {
    return path.includes(route);
  });

  const AgentMenuNavbar = [
    "/manual-entry",
    "/resend-notification",
    "/manual-verification",
    "/main-gate-entry-back",
    "/add-booking",
    "/main-gate-entry-front",
    "/booking-stats",
    "/guard-flow",
    "/warden-flow",
    "/scan-qr",
    "/guest-verification",
    "/guard-user-details",
  ].some((route) => path.includes(route));

  const showLoader =
    !mainContentLoaded || (!authStatus.isComplete && authStatus.isLoading);

  return (
    <>
      <CssBaseline />
      <GlobalStyle />

      {showLoader && <WebsiteLoader />}

      {!authStatus.isLoading && (
        <ContentWrapper>
          <MainContentWrapper>
            {!showNavbar && <Navbar />}
            {!showMenuNavbar && <MenuNavbar />}
            {AgentMenuNavbar && <AgentNavbar />}
            {mainContentLoaded && <MainContent />}
            {showFooter && <Footer />}
            <PoweredBy />
          </MainContentWrapper>
        </ContentWrapper>
      )}
    </>
  );
}
